"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleCheckbox_1 = require("./RawExampleCheckbox");
var LabelExampleCheckbox_1 = require("./LabelExampleCheckbox");
var CheckedExampleCheckbox_1 = require("./CheckedExampleCheckbox");
var StylingExampleCheckbox_1 = require("./StylingExampleCheckbox");
var PropertiesCheckbox_1 = require("./PropertiesCheckbox");
exports.ComponentCheckboxPage = function () { return (React.createElement(common_1.Page, { headerText: "Checkbox" },
    React.createElement(common_1.Paragraph, null, "Checkbox is used to mark some option."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleCheckbox_1.RawExampleCheckbox, null),
    React.createElement(LabelExampleCheckbox_1.LabelExampleCheckbox, null),
    React.createElement(CheckedExampleCheckbox_1.CheckedExampleCheckbox, null),
    React.createElement(StylingExampleCheckbox_1.StylingExampleCheckbox, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesCheckbox_1.PropertiesCheckbox, null))); };
exports.ComponentCheckboxPage.displayName = 'ComponentCheckboxPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCheckboxPage/ComponentCheckboxPage.tsx
// module id = 647
// module chunks = 0